export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-screen flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-5 whitespace-nowrap">
              <i className="ri-fire-fill mr-1.5"></i>每日更新 · 全网同步
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              番茄影视大全
              <span className="block text-primary-600 mt-1">最新电视剧免费在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-5 leading-relaxed">
              追剧不等待，高清不缓冲，全网热播一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-6">
              番茄影视大全专注电视剧在线观看，每日同步更新各大平台最新剧集资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等丰富内容。无论是正在热播的都市情感剧、古装悬疑剧，还是经典怀旧老剧，在这里都能找到。高清画质搭配极速加载，无需下载即可流畅追剧，让每一部好剧触手可及。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-movie-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700">
                  <strong className="text-primary-600">12,000+</strong> 部剧集资源
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700">
                  每日 <strong className="text-primary-600">实时同步</strong> 更新
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700">
                  全链路 <strong className="text-primary-600">高清保障</strong>
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap text-center text-sm cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>开始追剧
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg transition-all whitespace-nowrap text-center text-sm cursor-pointer border border-background-300/60"
              >
                <i className="ri-fire-line mr-2"></i>查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20widescreen%20composition%20depicting%20a%20modern%20streaming%20entertainment%20scene%2C%20abstract%20floating%20film%20reels%20and%20glowing%20theatrical%20light%20beams%20in%20warm%20crimson%20red%20and%20golden%20amber%20tones%2C%20dark%20sophisticated%20theater%20atmosphere%2C%20minimalist%20design%20aesthetic%2C%20soft%20dramatic%20lighting%20with%20gentle%20bokeh%20effects%2C%20no%20text%20or%20visible%20branding%2C%20clean%20elegant%20cinematic%20feel%2C%20editorial%20photography%20style%20with%20rich%20contrast&width=800&height=600&seq=tomato-hero-main&orientation=landscape"
                  alt="番茄影视大全 - 最新电视剧免费在线观看平台，高清热播剧集一网打尽"
                  className="w-full h-auto object-cover"
                  width="800"
                  height="600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none"></div>
              </div>
              <div className="absolute -bottom-3 -left-3 w-20 h-20 bg-accent-500/20 rounded-2xl -z-10"></div>
              <div className="absolute -top-3 -right-3 w-16 h-16 bg-primary-500/15 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}